import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { mergeClassNames } from '../../utils';
/**
 * @deprecated use ~/components/Select instead
 */
const __deprecated_Select = ({ id, value, name, autoComplete, className, onChange, onBlur, selectOptions, ariaDescribedBy, hasError, baseClasses, disabled, }) => {
    const { errorClasses, standardClasses } = baseClasses;
    const classes = mergeClassNames(className, 'shadow-sm block w-full sm:text-sm rounded-md', `${hasError ? errorClasses : standardClasses}`);
    return (_jsx(_Fragment, { children: _jsx("select", { id: id, value: value, name: name, autoComplete: autoComplete, className: classes, onChange: onChange, onBlur: onBlur, "aria-describedby": ariaDescribedBy, "aria-invalid": hasError, disabled: disabled, children: selectOptions &&
                selectOptions?.map(({ name, value }) => {
                    return (_jsx("option", { value: value, children: name }, value));
                }) }) }));
};
__deprecated_Select.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    selectOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
    ariaDescribedBy: PropTypes.string,
};
__deprecated_Select.defaultProps = {
    id: '',
    onChange: () => { },
};
export default __deprecated_Select;
